var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_2352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7707 18.6661L14.128 13.0234C16.6989 9.89548 16.5239 5.25216 13.6026 2.33083C10.4948 -0.776943 5.43812 -0.776943 2.33034 2.33083C-0.777432 5.4386 -0.777432 10.4953 2.33034 13.6031C5.25089 16.5236 9.89362 16.7004 13.0229 14.1285L18.6656 19.7711C18.9707 20.0763 19.4655 20.0763 19.7706 19.7711C20.0758 19.4659 20.0758 18.9712 19.7707 18.6661ZM12.4975 12.498C9.99909 14.9964 5.93386 14.9964 3.43542 12.498C0.936983 9.99954 0.936983 5.93431 3.43542 3.43587C5.93378 0.937549 9.99901 0.937353 12.4975 3.43587C14.996 5.93431 14.996 9.99954 12.4975 12.498Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7927 7.18531H8.74813V4.14078C8.74813 3.70922 8.39828 3.35938 7.96672 3.35938C7.53516 3.35938 7.18531 3.70922 7.18531 4.14078V7.18531H4.14078C3.70922 7.18531 3.35938 7.53516 3.35938 7.96672C3.35938 8.39828 3.70922 8.74813 4.14078 8.74813H7.18531V11.7927C7.18531 12.2242 7.53516 12.5741 7.96672 12.5741C8.39828 12.5741 8.74813 12.2242 8.74813 11.7927V8.74813H11.7927C12.2242 8.74813 12.5741 8.39828 12.5741 7.96672C12.5741 7.53516 12.2242 7.18531 11.7927 7.18531Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.31590141f2cfff578a1247cb335a5981.svg";
export { ForwardRef as ReactComponent };